import { FC, useState } from 'react';
import { getAmountWithCurrency } from 'utils/amountUtils';
import { CaretDownGreyIcon, ChevronArrowRightIcon } from 'assets/icons';
import { ReservedFund } from 'containers/payouts/payouts.model';
import DateUtils from 'utils/dateUtils';
import { HeldInReserveStatus } from 'containers/payouts/constants';

interface HoldAndReleaseCardProps {
  reservedFund: ReservedFund;
  onViewPaymentClick?: (id: string) => void;
}

const HoldAndReleaseCard: FC<HoldAndReleaseCardProps> = ({ reservedFund, onViewPaymentClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandClick = () => {
    if (reservedFund.hasAccess) {
      setIsExpanded(prev => !prev);
    }
  };

  const handleViewPaymentClick = () => {
    if (onViewPaymentClick) onViewPaymentClick(reservedFund.transactionId);
  };

  return (
    <div>
      <div
        className={reservedFund.hasAccess ? 'cursor-pointer' : 'pointer-events-none cursor-default'}
        onClick={handleExpandClick}>
        <div className="flex justify-between">
          <div>
            <div className="text-17px font-semibold text-primaryText">
              Reserved from <br /> {reservedFund.transactionId}
            </div>
            <div className="mt-3.5 text-sbase text-primaryText">
              Available on{' '}
              {DateUtils.getDateInFormat({ date: new Date(reservedFund.releaseDate), dateFormat: 'dd MMM yyyy' })}
            </div>
          </div>
          <div className="flex items-start gap-2">
            <div className="space-y-1 text-right">
              <div className="text-17px font-semibold text-primaryText">
                {getAmountWithCurrency(reservedFund.reservedAmount ?? '')}
              </div>
              <div
                className={`text-right text-sbase capitalize ${
                  reservedFund.status === HeldInReserveStatus.HELD ? 'text-pending-orange' : 'text-successHighlight'
                }`}>
                {reservedFund.status.toLowerCase()}
              </div>
            </div>
            <CaretDownGreyIcon className={`mt-2 ${isExpanded ? 'rotate-180' : ''}`} />
          </div>
        </div>
      </div>
      {isExpanded && (
        <div className="mt-4">
          {reservedFund.comment && (
            <div className="mb-3 max-w-[99%] break-words text-sbase text-primaryText line-clamp-2">
              {reservedFund.comment}
            </div>
          )}
          {reservedFund.hasAccess && (
            <div
              role="presentation"
              onClick={handleViewPaymentClick}
              className="flex w-fit cursor-pointer items-center gap-2 rounded-md bg-secondaryBtn py-1.5 px-4">
              <div className="text-sbase text-secondary">View related payment</div>
              <div>
                <ChevronArrowRightIcon className="path-fill-current path text-border" />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HoldAndReleaseCard;
